<template>
  <nav
    class="ods-breadcrumb ods-margin-top-1 ods-margin-top-2-breakpoint-medium ods-margin-left-4 ods-margin-left-8-breakpoint-large"
  >
    <ul class="ods-breadcrumb__list">
      <li class="ods-breadcrumb__item">
        <a
          v-if="href.startsWith('http') || href.startsWith('mailto')"
          :href="href"
          class="ods-breadcrumb__link"
          aria-label="Gå tilbake et steg"
          >{{ text }}</a
        >
        <router-link v-else :to="href" class="ods-breadcrumb__link" aria-label="Gå tilbake et steg">{{
          text
        }}</router-link>
      </li>
    </ul>
  </nav>
</template>
<script>
export default {
  name: 'OdsBackLink',
  props: {
    text: {
      type: String,
      required: false,
      default: 'oslo.kommune.no',
    },
    href: {
      type: String,
      required: false,
      default: 'https://www.oslo.kommune.no',
    },
  },
};
</script>
